import __request__ from "routing/request";
export function clusterHealth() {
  return __request__("GET", "/system/indexer/cluster/health", null, {}, {
    "Accept": ["application/json"]
  });
}
export function clusterInfo() {
  return __request__("GET", "/system/indexer/cluster/info", null, {}, {
    "Accept": ["application/json"]
  });
}
export function clusterName() {
  return __request__("GET", "/system/indexer/cluster/name", null, {}, {
    "Accept": ["application/json"]
  });
}
